import { useEffect } from 'react';
import type React from 'react';
import { useLocation } from 'react-router-dom';

export function useSectionHashTabSwitch<T extends string>(
  sectionTabMap: Record<string, T>,
  setActiveTab: React.Dispatch<React.SetStateAction<T>>,
): void {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;
    if (!hash.startsWith('#section-')) return;

    const sectionId = hash.slice('#section-'.length);
    const tab = sectionTabMap[sectionId];
    if (tab) setActiveTab(tab);
  }, [location.hash, sectionTabMap, setActiveTab]);
}
